<template>
<div>
    <v-card dark class="pa-4 grey darken-3 ma-4">
        <v-toolbar dark flat dense class="grey darken-3">
            <v-toolbar-title>Історія продажу Megogo Епіцентр</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-data-table :headers="headers" :items="list" :footer-props="footerProps" :search="search" class="ma-4" @click:row="openCard($event.id)">
                <template v-slot:no-data>
                    ...
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'


export default {
    data() {
        return {
            f: {},
            usersTable: false,
            search: '',
            footerProps: {
                'items-per-page-options': [20, 40, 100],
                'items-per-page-text': 'на стор.'
            },
            headers: [
                {
                    text: 'Дата продажу',
                    align: 'left',
                    sortable: true,
                    value: 'sell_date',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Ким продано',
                    align: 'left',
                    sortable: true,
                    value: 'seller',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Документ Тайфун',
                    align: 'left',
                    sortable: true,
                    value: 'typhoon_doc',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Контрагент продажу',
                    align: 'left',
                    sortable: true,
                    value: 'contractor',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'ПІБ покупця',
                    align: 'left',
                    sortable: true,
                    value: 'fio',
                    selected: false,
                    width: '10%',
                },
                {
                    text: 'Телефон покупця',
                    align: 'left',
                    sortable: true,
                    value: 'phone',
                    selected: false,
                    width: '10%',
                },
                
            ]
        }
    },
    methods: {
        ...mapActions(['setSnackbar', 'touch','getEpicentrkSellHistory']),
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
        },
        openCard(id) {
            this.$router.push('/adminpanel/epicentrk-megogo-package-selling-history/'+id)
        },
    },
    created() {
        this.getEpicentrkSellHistory()
    },
    computed: {
        list() {
            return this.$store.state.adminpanel.sellEpicentrkHistoryList || []
        },
    },
    watch: {}
}
</script>

<style>
.inp-cnt {
    color: black;
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid rgb(7, 0, 0);
    width: 40px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}
</style>
